module.exports = __webpack_public_path__ + "static/collaborate-with-team-ddce5d96d2fc31ccd5e8034045c7299f.png";